import React, { useContext } from 'react';
import { Select } from 'antd';
import { ApplicationUIContext, Form } from '@yuhuinc/ui-library';
import { getTranslatedString } from 'helpers/i18n';

const DenyApplicationForm = ({ denialReasons, form, onSubmit }) => {
  const { isMobile } = useContext(ApplicationUIContext);

  return (
    <Form
      preserve={false}
      layout="vertical"
      size={isMobile && 'large'}
      form={form}
      onFinish={onSubmit}
    >
      <Form.Item
        name="deny_reason"
        label={getTranslatedString(
          'landlordPortal.applicationManagement.applicationOverview.review.actions.deny.reasonCode'
        )}
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Select>
          {denialReasons.map((reason) => {
            return (
              <Select.Option key={reason} value={reason}>
                {reason}
              </Select.Option>
            );
          })}
        </Select>
      </Form.Item>
    </Form>
  );
};

export default DenyApplicationForm;
